(() => {
  const root = document.getElementById('br-delivery-inquiry');
  if (!root) return;
  const dialog = root.querySelector('dialog');
  const trigger = root.querySelector('.br-delivery-trigger');
  const form = root.querySelector('form');
  const status = root.querySelector('[data-delivery-status]');
  const submit = root.querySelector('[data-delivery-submit]');
  let sourceForm = null;
  let sequence = 0;
  const productForms = [...document.querySelectorAll('#MainContent form[action*="/cart/add"]')];
  sourceForm = productForms.find(f => f.closest('[data-section-type="product"]')) || productForms[0];
  const anchor = sourceForm?.closest('.product-single__meta') || document.querySelector('#MainContent .product-single__meta');
  if (sourceForm) {
    let position = sourceForm;
    while (position.parentElement?.closest('form')) position = position.parentElement;
    position.insertAdjacentElement('afterend', root);
  } else if (anchor) anchor.append(root);
  else document.getElementById('MainContent')?.prepend(root);
  const selectedId = () => sourceForm ? String(new FormData(sourceForm).get('id') || '') : new URL(location.href).searchParams.get('variant') || root.dataset.initialVariant;
  async function refresh() {
    if (!submit) return;
    const ticket = ++sequence;
    submit.disabled = true;
    form.querySelector('[data-delivery-body]').value = '';
    status.textContent = status.dataset.loading;
    try {
      const id = selectedId();
      if (!/^\d+$/.test(id)) throw new Error('Variant missing');
      const url = new URL(location.href);
      url.searchParams.set('variant', id);
      url.searchParams.set('section_id', 'br-delivery-data');
      const response = await fetch(url, {credentials:'same-origin'});
      if (!response.ok) throw new Error('Product request failed');
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const template = doc.querySelector('#br-delivery-data');
      const encoded = template?.innerHTML;
      const decoder = document.createElement('textarea');
      decoder.innerHTML = encoded || '';
      const data = JSON.parse(decoder.value);
      if (ticket !== sequence) return;
      if (data.variant_id !== id || data.product_id !== root.dataset.productId) throw new Error('Variant mismatch');
      const link = new URL(data.url, location.origin);
      link.searchParams.set('variant', id);
      const details = {
        Anfrageart:'Lieferzeitanfrage', Artikel:data.product, Hersteller:data.vendor,
        Variante:data.variant, SKU:data.sku || 'Nicht hinterlegt', EAN:data.ean || 'Nicht hinterlegt',
        Produkt_ID:data.product_id, Varianten_ID:id, Produktlink:link.href,
        Im_Shop_verfuegbar:data.available ? 'Ja' : 'Nein',
        Anfragezeit:new Date().toISOString()
      };
      form.querySelector('[data-delivery-body]').value = Object.entries(details).map(([key,value]) => key + ': ' + value).join('\n');
      root.querySelector('[data-delivery-summary]').textContent = data.product + (data.variant === 'Default Title' ? '' : ' · ' + data.variant) + (data.sku ? ' · SKU: ' + data.sku : '');
      status.textContent = '';
      submit.disabled = false;
    } catch (error) {
      if (ticket === sequence) status.textContent = status.dataset.error;
    }
  }
  trigger.addEventListener('click', () => { dialog.showModal(); refresh(); });
  root.querySelector('.br-delivery-close').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', event => { if(event.target === dialog) { const r=dialog.getBoundingClientRect(); if(event.clientX<r.left || event.clientX>r.right || event.clientY<r.top || event.clientY>r.bottom) dialog.close(); } });
  document.addEventListener('change', event => { if(dialog.open && sourceForm?.contains(event.target)) setTimeout(refresh,0); });
  form.addEventListener('submit', event => {
    if (submit?.disabled || !form.querySelector('[data-delivery-body]')?.value) event.preventDefault();
    else { submit.disabled = true; }
  });
  if (root.querySelector('[data-delivery-result]')) dialog.showModal();
})();